import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  styleUrls: ['./auth-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthShellComponent implements OnInit {
  constructor(public uiService: UiService) {}

  ngOnInit() {}
}
